/* eslint-disable no-extra-parens */
import React, { useEffect, useRef } from 'react';
import { reduxConnect } from '../../common';
import { IStoreState } from '../common/interfaces/types';

const gtMediaCampaignImgTagId = 'gt-media-campaign-for-wb-site-v1';

const targettedPagesPageId = [
    'forecasts/current',
    'appDownload'
]; 

interface GTMediaCampaignProps {
    gTMediaCampaignIsEnabled: boolean;
    homePagePixelImgSourceUrl: string;
    appDownloadPagePixelImgSourceUrl: string;
    pageId: string;
}

const mapStoreStateToProps = (storeState: IStoreState) => {
    const { gTMediaCampaignIsEnabled, homePagePixelImgSourceUrl, appDownloadPagePixelImgSourceUrl, pageId } = storeState?.appState?.appState || {};

    return {
        gTMediaCampaignIsEnabled, 
        homePagePixelImgSourceUrl, 
        appDownloadPagePixelImgSourceUrl, 
        pageId
    };
};

const mapDispatchToProps = {};

const formatGTCampaignPixelURL = (baseURL: string): string => {
    const gtCampaignPixelUrl = new URL(baseURL);
    gtCampaignPixelUrl.searchParams.append('ts', `${Date.now()}`);
    return gtCampaignPixelUrl.toString();
};

export const GTMediaCampaign =  reduxConnect(mapStoreStateToProps, mapDispatchToProps)(({
    gTMediaCampaignIsEnabled, 
    homePagePixelImgSourceUrl, 
    appDownloadPagePixelImgSourceUrl, 
    pageId }: GTMediaCampaignProps) => {

    const didLoadCampaignTag = useRef<boolean>(false);
    const prevPageId = useRef<string>('');

    useEffect(() => {
        const gtCampaignPixelTag: HTMLElement | null = document.getElementById(gtMediaCampaignImgTagId);

        // Need this ensure that this only runs once for supported pages, also considering appstate bug that sometimes returns undefined values.
        if (pageId
            && (!didLoadCampaignTag.current 
                || (didLoadCampaignTag.current && prevPageId.current !== pageId)) // handles scenarios wheen you are moving between pages that are targetted in the campaign.
            && targettedPagesPageId.includes(pageId)
            && gTMediaCampaignIsEnabled 
            && (homePagePixelImgSourceUrl || appDownloadPagePixelImgSourceUrl)) {
            
            if (gtCampaignPixelTag) {
                gtCampaignPixelTag.remove();
            }
            
            const gtCampaingImgTag = document.createElement('img');

            gtCampaingImgTag.id = gtMediaCampaignImgTagId;

            if (targettedPagesPageId[0] === pageId && homePagePixelImgSourceUrl) {

                gtCampaingImgTag.src = formatGTCampaignPixelURL(homePagePixelImgSourceUrl);
            } else if (targettedPagesPageId[1] === pageId && appDownloadPagePixelImgSourceUrl) {
                gtCampaingImgTag.src = formatGTCampaignPixelURL(appDownloadPagePixelImgSourceUrl);
            }

            gtCampaingImgTag.width = 0;
            gtCampaingImgTag.height = 0;
            document.body.appendChild(gtCampaingImgTag);
            didLoadCampaignTag.current = true;
            prevPageId.current = pageId;
        }

        if (gtCampaignPixelTag
            && didLoadCampaignTag.current 
            && ((pageId 
                && prevPageId.current)
                && prevPageId.current !== pageId)) { // ALWAYS remove tag as we move to a new page change.
            
            didLoadCampaignTag.current = false;
            prevPageId.current = pageId;
            gtCampaignPixelTag.remove();
        }

    }, [gTMediaCampaignIsEnabled, homePagePixelImgSourceUrl, appDownloadPagePixelImgSourceUrl, pageId]);

    return null;
});
